import {
  createFileRoute,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/$clientId/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>Hello "/_app/_authenticated/mydigitalworkers/omni/$clientId"!</div>
  );
}
